<button class="macro-button default no-underline" #macroButton type="button"
   (click)="navigateToUrl($event)"
   [class]="style">
    @if (showIcon) {
        <bizz-icon class="size-4"
                   [iconLibrary]="icon.Library"
                   [iconName]="icon.Name"></bizz-icon>
    }
    @if (showCaption) {
        <span>{{ caption }}</span>
    }
</button>